import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LaCucinaDiOrietta from "./components/LaCucinaDiOrietta";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LaCucinaDiOrietta />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
